import { Callout, Dialog, Snackbar } from "@octopusdeploy/design-system-components";
import { useInlineStatusMutation } from "@octopusdeploy/octopus-react-client";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import React, { useState } from "react";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import RequestFreeTrialDialog from "~/components/DialogLayout/RequestFreeTrialDialog";
type RequestFreeTrialUpsellProps = {
    featureName: string;
    onRequestTrial: (repository: Repository) => Promise<void>;
    docsLink: string;
    docsLabel: string;
    dialogTitle: string;
    children: React.ReactNode;
    trackOpeningRequestDialog?: () => void;
    onTrialRequested?: () => void;
};
function RequestFreeTrialUpsellCallout({ featureName, onRequestTrial, docsLink, docsLabel, dialogTitle, children, trackOpeningRequestDialog, onTrialRequested }: RequestFreeTrialUpsellProps) {
    const [showSnackbar, setShowSnackbar] = useState(false);
    const { openDialog, isOpen: isDialogOpen, closeDialog } = useDialogTrigger();
    const { execute: requestTrial, isExecuting: isRequestingTrial, error: errorRequestingTrial, } = useInlineStatusMutation({
        action: onRequestTrial,
        name: `request free trial ${featureName}`,
        afterComplete: async () => {
            setShowSnackbar(true);
            onTrialRequested?.();
        },
    });
    return (<>
            <Callout actions={{
            primary: {
                label: "Request Free Trial",
                onClick: () => {
                    trackOpeningRequestDialog?.();
                    openDialog();
                },
            },
            secondary: {
                href: docsLink,
                label: docsLabel,
            },
        }} title="Available on the Enterprise tier" type="upsell">
                {children}
            </Callout>
            <Dialog open={isDialogOpen}>
                <RequestFreeTrialDialog dialogTitle={dialogTitle} onRequestTrial={requestTrial} errors={errorRequestingTrial ? [errorRequestingTrial] : undefined} busy={isRequestingTrial}/>
            </Dialog>
            <Snackbar open={showSnackbar} autoHideDuration={8000} onClose={() => setShowSnackbar(false)} content={"Trial request sent. We\u2019ll email you shortly with the details."} textAlign={"center"}/>
        </>);
}
export default RequestFreeTrialUpsellCallout;
